<app-page-header [title]="componentTitle" subTitle="Feedback about the EVA system from users"></app-page-header>

<div>
  <ag-grid-angular class="ag-grid-container ag-theme-balham" [gridOptions]="gridOptions"
    (cellValueChanged)="onCellValueChanged($event)" (columnResized)="onColumnResized()" [defaultColDef]="defaultColDef">
  </ag-grid-angular>
</div>